import { useParams } from 'react-router-dom';
import ProjectEdit from './ProjectEdit';
import ProjectNew from './ProjectNew';

export default function Project() {

    const {id} = useParams()

    if (id === 'new') return <ProjectNew/>

    return (<ProjectEdit id={id}/>)
}